import React, { FC, HTMLInputTypeAttribute, InputHTMLAttributes, useState } from 'react'
import "./passwordInputWithIcon.scss"
import { svgs } from '../common/assats'
import { useTranslation } from 'react-i18next'
import { useNavigate } from "react-router-dom";

interface PasswordInputWithIconProps {
    value: string
    setValue: (str: string) => void
    placeholder: string
    label: string
    inputName?: string //if not passed no errors will be displayed
    errors: Record<string, string[]>
    filedCorrect?: boolean
    showForgotPassword?: boolean;

}
const PasswordInputWithIcon: FC<PasswordInputWithIconProps> = ({ filedCorrect, errors, inputName, label, placeholder, setValue, value,showForgotPassword=true  }) => {
    const [showPassword, setShowPassword] = useState(false);
    const { t } = useTranslation();
    const getText = (text: string) => t(`login.${text}`);
    const navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    function forgotPassword(event: React.MouseEvent<HTMLButtonElement>): void {
        event.preventDefault();
        navigate("/ForgotPassword");
    }

    return (
      <div key={inputName} className="Password-input-with-icon-main-wrapper">
        <div className="label-and-forgot-password">
          <span className="label">{label}</span>
          {showForgotPassword && (
            <button onClick={forgotPassword} className="forgot-password-link">
              {getText("Forgot_password")}
            </button>
          )}
        </div>
        <div
          className={`text-input-with-icon-main-container ${
            filedCorrect !== undefined && (filedCorrect ? "correct" : "wrong")
          }`}
        >
          <div
            className="icon-container flex-center"
            onClick={togglePasswordVisibility}
          >
            {showPassword ? <svgs.logos.OpenEye /> : <svgs.logos.ClosedEye />}
          </div>
          <input
            onChange={(e) => setValue(e.target.value)}
            value={value}
            placeholder={placeholder}
            type={showPassword ? "text" : "password"}
            className="input-container"
          ></input>
        </div>
        {inputName &&
          errors?.[inputName] &&
          errors?.[inputName].map((val) => (
            <span className="error-text">{" " + val + " "}</span>
          ))}
      </div>
    );
}

export default PasswordInputWithIcon